import React from 'react';
import { Modal } from 'antd';
import './Imageviewmodal.scss';

export interface ImageViewModalProps {
  src: string;
  alt?: string;
  visible: boolean;
  onClose: () => void;
}

const ImageViewModal: React.FC<ImageViewModalProps> = ({
  src,
  alt = 'image',
  onClose,
  visible
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={false}
      centered
      width="90vw"
    >
      <div className="ImageviewmodalStyles">
        <img src={src} alt={alt} />
      </div>
    </Modal>
  );
};

export default ImageViewModal;
